module.exports = __webpack_public_path__ + "static/media/revenue_ops_use_case_4.59f9faf4.svg";